import { Component, Input, OnInit } from '@angular/core';
import { DoutoradoService } from 'app/pos-graduacao/doutorado/service/doutorado.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'curso-cartao-mosaico',
  templateUrl: './curso-cartao-mosaico.component.html',
  styleUrls: ['./curso-cartao-mosaico.component.scss'],
})
export class CursoCartaoMosaicoComponent implements OnInit {
  environment = environment;
  srcImg: string;

  @Input() curso;

  constructor(
    private doutoradoService: DoutoradoService,
    ) { }

  ngOnInit() {
    const path = this.curso._links['wp:featuredmedia'][0].href

    this.doutoradoService.getImage(path).then(href => this.srcImg = href)
  }
}
